var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabaseRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2D85A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C11.748 22.5 9 20.9738 9 19.167V10.833C9 9.02625 11.748 7.5 15 7.5C18.252 7.5 21 9.02625 21 10.833V19.167C21 20.9738 18.2528 22.5 15 22.5ZM10.5 17.175V19.1693C10.5525 19.584 12.2318 20.8358 15 20.8358C17.7682 20.8358 19.4482 19.5803 19.5 19.1648V17.175C18.1346 17.9665 16.5779 18.3679 15 18.3353C13.422 18.3679 11.8654 17.9666 10.5 17.175ZM10.5 13.0058V15C10.5525 15.4148 12.2318 16.6665 15 16.6665C17.7682 16.6665 19.4482 15.411 19.5 14.9955V13.0058C18.1346 13.7976 16.578 14.1992 15 14.1667C13.422 14.1992 11.8653 13.7976 10.5 13.0058ZM15 9.1665C12.231 9.1665 10.5517 10.422 10.5 10.8383C10.5525 11.25 12.2333 12.4995 15 12.4995C17.7668 12.4995 19.4482 11.244 19.5 10.8285C19.4475 10.4153 17.7668 9.1665 15 9.1665Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseRounded);
export default __webpack_public_path__ + "static/media/databaseRounded.9e1563b3585ee497f17cd66b928debcc.svg";
export { ForwardRef as ReactComponent };